import Menu from "./Menu";
import Header from "./Header";
import Carousel from "./Carousel";
import EmbedVideo from "./EmbedVideo";
import ReadMore from "./ReadMore";
import Frames from "./tileblock/animation/Frames";
import Form from "./Form";
import Field from "./Field";
import PlatoViewer from "./acajou/PlatoViewer";
import Confirm from "./Confirm";
import Hover from "./Hover";
import EditableList from "./EditableList";
import SizeObserver from "./SizeObserver";
import LexiconDefinition from "./LexiconDefinition";
import BreadcrumbDropdown from "./BreadcrumbDropdown";
import BreadcrumbDropdownToggle from "./BreadcrumbDropdownToggle";
import ReadMoreLineclamp from "./ReadMoreLineclamp";


export default {
    'aca-menu': Menu,
    'aca-header': Header,
    'aca-carousel': Carousel,
    'aca-embed-video': EmbedVideo,
    'aca-read-more': ReadMore,
    'aca-read-more-lineclamp': ReadMoreLineclamp,
    'aca-frames': Frames,
    'aca-form': Form,
    'aca-field': Field,
    'aca-plato-viewer': PlatoViewer,
    'aca-confirm': Confirm,
    'aca-hover': Hover,
    'aca-breadcrumb-dropdown': BreadcrumbDropdown,
    'aca-breadcrumb-dropdown-toggle': BreadcrumbDropdownToggle,
    'platoviewer': PlatoViewer, // smaller form to be used in markdown
    'aca-lexicon-definition': LexiconDefinition,
    EditableList,
    'size-observer': SizeObserver,
}
